import React from 'react';

import { useApp } from '../../../store/AppContext';
import { orderedRange } from './lanes';
import { cell, dayBorder } from './style';

/* Fond d'un jour dans une ligne : sélection en cours, férié, week-end / jour non travaillé,
   aujourd'hui. `match` identifie la ligne ({ devId } ou { rowKey }). */
export default function TimelineDayCell({ day, match, notWork }) {
  const { timelineDrag, timelineZoom } = useApp();
  const [field, value] = Object.entries(match)[0];
  const nw = notWork(day);
  let inSel = false;
  if (timelineDrag?.[field] === value) {
    const [s, e] = orderedRange(timelineDrag);
    inSel = day.iso >= s && day.iso <= e && !day.we && !day.ferie && !nw;
  }
  const bg = inSel
    ? '#D5EBF7'
    : day.ferie
      ? '#EEF5FC'
      : day.we || nw
        ? '#f7f5f0'
        : day.today
          ? '#E1DAFB'
          : '#fff';
  return <div style={cell({ borderRight: dayBorder(day, timelineZoom), background: bg })} />;
}
